export default "__VITE_ASSET__7ef98419__"